import React from 'react'

import FeatureItem from './FeatureItem'

import type { FeatureItemProps } from './FeatureItem'

interface Props {
  features: FeatureItemProps[]
}

const FeatureList: React.FC<Props> = ({ features }: Props) => {
  return (
    <ul className="list-none">
      {features.map((feature) => (
        <FeatureItem key={feature.icon} {...feature} />
      ))}
    </ul>
  )
}

export default FeatureList
